import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'app-encabezado-pagina',
  templateUrl: './encabezado-pagina.component.html',
  styleUrls: ['./encabezado-pagina.component.css'],
  standalone: false,
})
export class EncabezadoPaginaComponent {
  @Input() titulo: string = ''
  @Input() icono: string = 'bi-file-earmark'
  @Input() mostrarVolver: boolean = true
  @Input() tooltipVolver: string = 'Volver'

  @Output() volver = new EventEmitter<void>()

  public regresar(): void {
    this.volver.emit()
  }
}
